// Show-aware editorial playback must not depend on GPT loading or Pro ad slots.
function initShowAwareArticle(init, options, ctx, device) {
  if (!options.showAware || options.contentEnabled === false || typeof document === 'undefined') return;
  if (ctx._sponsored === 'yes' || ctx._noads === 'yes' || ctx._urlonly === 'yes') return;
  const mount = () => {
    if (!document.querySelector('.stories-player-container')) {
      const sidebar = device === 'desktop' && document.querySelector('.sidebar');
      const article = document.querySelector('.body-description, article, .article-body');
      // A walled view keeps the player out of the body (plans/dynamic-login-wall.md).
      const parent = sidebar || (!ctx.walled && article);
      if (!parent) return;
      const container = document.createElement('div');
      container.className = 'stories-player-container';
      container.style.cssText = 'padding:15px;box-sizing:border-box;';
      const paragraph = !sidebar && Array.from(parent.querySelectorAll('p')).find((node) => !node.closest('.rm-shortcode, .rm-embed-container, figure'));
      if (paragraph) paragraph.after(container);
      else parent.append(container);
    }
    init(ctx);
  };
  // Let the existing editorial/ad placement finish first and reuse its container.
  const schedule = () => queueMicrotask(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
}
module.exports = { initShowAwareArticle };
